import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LoginFormWrapper,
  InputWrapper,
  Password,
  Caption,
  ButtonsWrapper,
  LogIn,
  Cancel,
  WrongLogin,
} from "./LoginFormStyles"
import { updateDimmed } from "../../../../features/forms/formsSlice";
import { API_URL } from "../../../../components/01_config/api";

// const API_URL = "http://localhost:4000";

const ResetPassword = ({ resetPasswordVisible }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // token comes from the query string: /reset-password?token=XYZ
  const token = new URLSearchParams(location.search).get("token");

  const [passwordValue, setPasswordValue] = useState("");
  const [confirmValue, setConfirmValue] = useState("");
  const [message, setMessage] = useState(""); // success or info
  const [error, setError] = useState("");     // error text
  const [loading, setLoading] = useState(false);

  // If the modal is not supposed to be visible, render nothing
  if (!resetPasswordVisible) return null;

  // If there is no token in the URL, show a simple "invalid link" message


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!passwordValue || passwordValue.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    if (passwordValue !== confirmValue) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          password: passwordValue,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.error || "Could not reset password.");
        setLoading(false);
        return;
      }

      setMessage("Password has been reset. You can now log in.");
      setLoading(false);

      // go to home page
        navigate("/");
    } catch (err) {
      setError("Server error. Please try again.");
      setLoading(false);
    }
    dispatch(updateDimmed(false))
  };

  const handleCancel = (e) => {
    e.preventDefault();
    dispatch(updateDimmed(false))
    navigate("/");
  };

  const handlePasswordChange = (e) => {
    setPasswordValue(e.target.value);
    if (error) setError("");
    if (message) setMessage("");
  };

  const handleConfirmChange = (e) => {
    setConfirmValue(e.target.value);
    if (error) setError("");
    if (message) setMessage("");
  };

  const showMessage = !!(error || message);


  if (!token) {
    return (
      <LoginFormWrapper
        loginVisible={resetPasswordVisible}
        style={{ right: "50%", transform: "translateX(50%)" }}
      >
        <Caption>Reset password</Caption>
        <WrongLogin showWrongLogin={true}>
          Reset link is invalid or has expired.
        </WrongLogin>
        <ButtonsWrapper>
          <Cancel onClick={handleCancel}>Back to home</Cancel>
        </ButtonsWrapper>
      </LoginFormWrapper>
    );
  }


  // Main reset-password modal
  return (
    <LoginFormWrapper
    loginVisible={resetPasswordVisible}
    style={{ right: "50%", transform: "translateX(50%)" }}
    >
      <InputWrapper>
        <Caption>New password:</Caption>
        <Password
          type="password"
          value={passwordValue}
          onChange={handlePasswordChange}
        />
      </InputWrapper>
      <InputWrapper>
        <Caption>Confirm new password:</Caption>
        <Password
          type="password"
          value={confirmValue}
          onChange={handleConfirmChange}
        />
      </InputWrapper>

      <WrongLogin showWrongLogin={showMessage}>
        {error || message}
      </WrongLogin>

      <ButtonsWrapper>
        <LogIn onClick={handleSubmit} disabled={loading}>
          {loading ? "Changing password..." : "Change password"}
        </LogIn>
        <Cancel onClick={handleCancel}>Cancel</Cancel>
      </ButtonsWrapper>
    </LoginFormWrapper>
  );
};

export default ResetPassword;
